const foldChar = (c) => (c.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()[0] || c.toLowerCase());

export const fold = (s) => [...(s || '')].map(foldChar).join('');

const clean = (s) => fold(s).replace(/\s+/g, ' ').replace(/ in$/, '').trim();

export const tokens = (q) => clean(q).split(' ').filter(Boolean);

export const matches = (ing, toks) => {
  if (!toks.length) return true;
  const hay = `${fold(ing.nombre_justo)} ${ing.id_justo.toLowerCase()}`;
  return toks.every((t) => hay.includes(t));
};

export const highlightRanges = (text, toks) => {
  const f = fold(text);
  const marks = new Array(text.length).fill(false);
  toks.forEach((t) => {
    let i = f.indexOf(t);
    while (t && i !== -1) { for (let k = i; k < i + t.length; k += 1) marks[k] = true; i = f.indexOf(t, i + t.length); }
  });
  const parts = [];
  [...text].forEach((ch, i) => {
    const last = parts[parts.length - 1];
    if (last && last.hit === marks[i]) last.text += ch; else parts.push({ text: ch, hit: marks[i] });
  });
  return parts;
};

const bigrams = (s) => { const out = new Set(); for (let i = 0; i < s.length - 1; i += 1) out.add(s.slice(i, i + 2)); return out; };

export const similarity = (a, b) => {
  const ca = clean(a).replace(/[^a-z0-9 ]/g, ''), cb = clean(b).replace(/[^a-z0-9 ]/g, '');
  const ba = bigrams(ca.replace(/ /g, '')), bb = bigrams(cb.replace(/ /g, ''));
  const inter = [...ba].filter((x) => bb.has(x)).length;
  const dice = ba.size + bb.size ? (2 * inter) / (ba.size + bb.size) : 0;
  const wa = ca.split(' ').filter((w) => w.length > 2), wb = cb.split(' ').filter((w) => w.length > 2);
  const words = wa.length ? wa.filter((w) => wb.some((x) => x.startsWith(w.slice(0, 4)) || w.startsWith(x.slice(0, 4)))).length / wa.length : 0;
  return dice * 0.6 + words * 0.4;
};

export const suggest = (name, catalogo, n = 3) => catalogo
  .map((i) => ({ i, s: similarity(name, i.nombre_justo) }))
  .filter((x) => x.s > 0.25)
  .sort((a, b) => b.s - a.s)
  .slice(0, n)
  .map((x) => x.i);

const UNIT_GROUPS = {
  un: ['unidad', 'unidades', 'un', 'und', 'u'], kg: ['kg', 'kgs', 'kilo', 'kilos'],
  lt: ['litro', 'litros', 'lt', 'l', 'lts'], g: ['g', 'gr', 'gramos', 'grs'], ml: ['ml', 'cc'],
};

const unitKey = (u) => {
  const v = fold(u).trim();
  return Object.keys(UNIT_GROUPS).find((k) => UNIT_GROUPS[k].includes(v)) || v;
};

export const sameUnit = (a, b) => !!a && !!b && unitKey(a) === unitKey(b);
